import html from "html-literal";

export default state => html`
  <header>
    <h1>${state.header}</h1>
  </header>
`;
//the state.header header is getting imported from
//the headers declared in the modules in the "./store" directory
